import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const HeroSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: { xs: 4, md: 5 },
        mb: 3,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
          fontWeight: 800,
          mb: 2,
          lineHeight: 1.2,
          background: `linear-gradient(135deg, ${theme.palette.text.primary} 0%, ${theme.palette.primary.main} 100%)`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontFamily: theme.typography.fontFamily,
        }}
      >
        Stratovai builds a living product brain for your product.
      </Typography>
      
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.4rem' },
          mb: 1,
          color: theme.palette.text.secondary,
          fontWeight: 400,
          lineHeight: 1.6,
          fontFamily: theme.typography.fontFamily,
          maxWidth: '700px',
        }}
      >
        Stratovai connects Figma, Jira, and tests — so teams know what will break before they ship.
      </Typography>
      
      <Typography
        variant="body1"
        sx={{
          fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
          mb: 0,
          color: theme.palette.text.secondary,
          fontWeight: 400,
          lineHeight: 1.5,
          fontFamily: theme.typography.fontFamily,
          maxWidth: '700px',
          opacity: 0.85,
        }}
      >
        See how Stratovai links real Figma screens, Jira bugs, and test cases to explain impact and root cause.
      </Typography>
    </Box>
  );
};

export default HeroSection;
